class BulkInvoiceItemTypesUploadDetailsPageTransform {
  constructor() {
    "ngInject";
  }

  justifyRecords(data) {
    data.forEach((record) => {
      record.data.forEach(({ field, value }) => {
        record[field] = value;
      });
    });

    return data;
  }
}

export default BulkInvoiceItemTypesUploadDetailsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/bulkInvoiceItemTypesUploadDetails/bulkInvoiceItemTypesUploadDetails.transforms.js